module.exports = __webpack_public_path__ + "img/profil-img.2b14bdf2.png";